/**
 * @generated SignedSource<<e870ea9fd341eba833950438f4909d7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateTicketingProfileInput = {
  emailSignature?: string | null;
  replyToEmail?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateTicketingProfileMutation$variables = {
  input: UpdateTicketingProfileInput;
};
export type updateTicketingProfileMutation$data = {
  readonly updateTicketingProfile: {
    readonly clientMutationId: string | null;
    readonly user: {
      readonly id: string;
      readonly emailSignature: string | null;
    } | null;
  } | null;
};
export type updateTicketingProfileMutation = {
  variables: updateTicketingProfileMutation$variables;
  response: updateTicketingProfileMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateTicketingProfilePayload",
    "kind": "LinkedField",
    "name": "updateTicketingProfile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountUser",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailSignature",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateTicketingProfileMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateTicketingProfileMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "aae4b8ae6104a8dfa4a5279f854b36e0",
    "id": null,
    "metadata": {},
    "name": "updateTicketingProfileMutation",
    "operationKind": "mutation",
    "text": "mutation updateTicketingProfileMutation(\n  $input: UpdateTicketingProfileInput!\n) {\n  updateTicketingProfile(input: $input) {\n    clientMutationId\n    user {\n      id\n      emailSignature\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c3b929e3f0313ce6364fe95cd0cada09";

export default node;
